import { UseFormReturn } from 'react-hook-form'
import MToast from '@/utils/modal/MToast'
import MConfirm from '@/utils/modal/MConfirm'
import { ShipperItem } from '@/services/shipper/types'

interface MutationHooks {
  createSalesPlatform: any
  updateSalesPlatform: any
  deleteSalesPlatform: any
  updateShipper: any
}

interface Operation {
  type: 'create' | 'update' | 'delete' | 'main'
  platform?: any
  index?: number
}

export const createExecuteOperations = (
  mutations: MutationHooks,
  shipperData: ShipperItem,
  form: UseFormReturn<any>,
  onRefresh: () => Promise<void>,
  onClose: () => void,
) => {
  const executeOperations = async (operations: Operation[]) => {
    const promises = operations.map((op) => {
      if (op.type === 'create') {
        return mutations.createSalesPlatform.mutateAsync({
          type: op.platform.type,
          name: op.platform.name!,
          companyId: op.platform.companyId!,
          usable: true,
        })
      } else if (op.type === 'update') {
        const originalPlatform = shipperData.salesPlatforms?.find((original) => original.masterCompanyId === op.platform.masterCompanyId)
        return mutations.updateSalesPlatform.mutateAsync({
          masterCompanyId: originalPlatform?.masterCompanyId || 0,
          newSalesPlatformName: op.platform.name !== originalPlatform?.name ? op.platform.name : undefined,
          newSalesPlatformType: op.platform.type !== originalPlatform?.type ? op.platform.type : undefined,
          newCompanyId: op.platform.companyId!,
          usable: op.platform.usable,
        })
      } else if (op.type === 'delete') {
        return mutations.deleteSalesPlatform.mutateAsync({
          type: op.platform.type,
          name: op.platform.name,
          companyId: op.platform.companyId,
        })
      } else if (op.type === 'main') {
        return mutations.updateShipper.mutateAsync(form.getValues())
      }
      return Promise.resolve()
    })

    const results = await Promise.allSettled(promises)

    if (results.every((result) => result.status === 'fulfilled')) {
      MToast.show('수정 완료 되었습니다.')
      setTimeout(() => {
        onRefresh()
        onClose()
      }, 100)
      return { success: true, results, operations }
    }

    return { success: false, results, operations }
  }

  const showRetryConfirm = (operations: Operation[]) => {
    MConfirm.show('일부 항목 저장에 실패했어요. 실패건을 확인하고 다시 시도해 주세요.', {
      subContent: `반복적으로 실패할 경우, 관리자에게 문의해 주세요.\n실패건 : ${operations.map((op) => op.platform?.name || op.type).join(', ')}`,
      confirmText: '다시 시도하기',
      closeText: '닫기',
      onConfirm: async () => {
        const retryResult = await executeOperations(operations)

        if (!retryResult.success) {
          // 재시도에서도 실패한 경우, 실패한 작업들로 다시 팝업 표시
          const retryFailedOperations = retryResult.operations.filter((_, index) => retryResult.results[index].status === 'rejected')
          showRetryConfirm(retryFailedOperations)
        }
      },
    })
  }

  return { executeOperations, showRetryConfirm }
}
